import React from 'react'
import PropTypes from 'prop-types'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { PickerField } from '@entrata/portals-common/lib/boxed-fields'
import ActionModal from './ActionModal'
import styled from '@emotion/styled'
import { connect } from 'react-redux'
import { updateEventAttendance } from 'portal-modules/events/redux/modules/events'

const StyledPickerField = styled(PickerField)`
  display: flex;
  width: 100%;
`

const StyledPickerFieldOption = styled(PickerField.Option)`
  flex: 1;
`

const EventModal = props => {
  const handleSubmit = ({ values }) => {
    props.onSubmit({
      id: props.id,
      is_attending: values.attending === '1',
    })
    props.onClose()
  }

  const initialFieldState = {
    attending: {
      required: true,
      value: props.is_attending ? (props.is_attending ? '1' : '0') : '0',
    },
  }

  return (
    <ActionModal {...props}>
      {() => (
        <Form onSubmit={handleSubmit} initialFieldState={initialFieldState}>
          <Form.Field name='attending'>
            {fieldProps => (
              <StyledPickerField {...fieldProps} label='' active='true'>
                <StyledPickerFieldOption value='1'>
                  {__('Attending')}
                </StyledPickerFieldOption>
                <StyledPickerFieldOption value='0'>
                  {__('Not Attending')}
                </StyledPickerFieldOption>
              </StyledPickerField>
            )}
          </Form.Field>
          <Form.Actions
            render={({ hasErrors }) => (
              <ActionModal.Button disabled={hasErrors} type='submit'>
                {__('SAVE')}
              </ActionModal.Button>
            )}
          />
        </Form>
      )}
    </ActionModal>
  )
}

EventModal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  is_attending: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default connect(
  null,
  { onSubmit: updateEventAttendance },
)(EventModal)
